module.exports = __webpack_public_path__ + "media/theme/dmm-825258b4.png";